<!--

Copyright Paul B. Lucas (C) 2023 -2026   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is rendered when an unauthorized error is returned from authentication processes
or when user exits processing completely.


Revisions:
    03/23/2026      pblucas     new Entra forced logout

-->
<template>
    <!-- Nothing to see here - NO CONTENT -->
</template>

<script>

    import useAuthAPI           from '@/composables/useAuthAPI'
    import { useStore }         from 'vuex'

    export default {
        name: 'Logout',

        emits: [
        ],

        setup()    {   
           
            const {handleLogout}        = useAuthAPI();
            const store                 = useStore()

            //  actions on store
            const setUser               =   (employee) => store.dispatch('setUser', employee)
            const setConfig             =   (config)   => store.dispatch('setConfig', config)

            localStorage.removeItem("user-netid") 
            localStorage.removeItem("config-uuid") 
            localStorage.removeItem("active-role")
            
            // clear store
            let nullUser = {
                'uuid':                   "00000000-0000-0000-0000-000000000000",
                'name-concat':            "",
                'first-name':             "",
                'last-name':              "",
                'middle-initial':         "",
                'ms-object-id':           "",
                'netid':                  "",
                'uin':                    "",
                'home-org':               "",
                'eclass-code':            "",
                'title':                  "",
                'address1':               "",
                "address2":               "",
                "city":                   "",
                "state":                  "",
                "postcode":               "",
                "country":                "",
                "mailcode":               "",
                "timezone":               "",
                "req-photo-suppress":     false,
                "college":                null,
                "college-code":           null,
                "department":             null,
                "department-code":        null,
                "division":               null,
                'division-code':          null,
                'contacts':               [],

                // defines initial screen shown
                'default-role':           "User",
        
                // security refinement
                'admins-multiple-orgs':   false,
                'allowed-orgs':           [],     


                // the following user properties will be replaced by membership in Entra seurity groups
                'is-sys-admin':           false,
                'is-dept-admin':          false,
                'is-receiver':            false,
                'is-it-support':          false,
                'is-auditor':             false                  
            }
            let nullConfig = {
                'uuid':                   "00000000-0000-0000-0000-000000000000",        
                'apply-college-code':     null,
                'apply-dept-code':        null,     
                'apply-orgcode':          null, 
                'notice':                 "",          
                'title':                  "University of Illinois Urbana-Champaign",  
                'title-link':             "https://illinois.edu",                  
                'suppress-photos':        false,  
                'suppress-cmdb-data':     false,
                'barcode-type':           "CODE128", 
                'tag-prefix':             "UN",
                'record-created-on':      "" 

            }
            setUser(nullUser)
            setConfig(nullConfig)

            handleLogout()
            
            // 2. Force App.vue to re-execute by reloading the page
            // Sometimes MSAL doesn't fully re-run main.ts/App.vue hooks on redirect,
            // so a hard window.location.reload() ensures complete re-init.
            window.location.href = '/'; 
            

        },
        data() {
            return {
            }
        },
        methods:    {
        },
        // hooks
        beforeMount() { 
        },
        mounted() {
        },
        beforeUpdate() {
        }
    }


</script>